<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Icon } from '@Shelly/shelly-design-system';

	/** Opens the dashboard edit (camera selection) so the user can slot a camera. */
	export let onAddCamera: () => void = () => {};
</script>

<div class="camera-placeholder">
	<div class="camera-placeholder-center">
		<Icon icon="fas fa-video" size="m" class="text-color-muted" />
		<button type="button" class="camera-placeholder-link" on:click={onAddCamera}>
			{$format('button_add_camera', { default: 'Add camera' })}
		</button>
	</div>
</div>

<style>
	.camera-placeholder {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		aspect-ratio: 16 / 9;
		height: auto;
		min-height: 0;
		border: 1px solid var(--color-3);
		border-radius: var(--radius-extra-big);
		background-color: color-mix(in srgb, var(--color-2) 40%, transparent);
		padding: var(--spacing-s);
		box-sizing: border-box;
	}

	/* Viewport-fit mosaic cells stretch the placeholder to the grid track. */
	:global(.camera-mosaic.fill-viewport) .camera-placeholder {
		aspect-ratio: unset;
		height: 100%;
	}

	.camera-placeholder-center {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--spacing-xs);
	}

	.camera-placeholder-link {
		background: none;
		border: none;
		padding: 0;
		cursor: pointer;
		color: var(--color-white);
		font-size: var(--font-size-body-extra-small, 12px);
		line-height: 1.2;
	}

	.camera-placeholder-link:hover {
		text-decoration: underline;
	}
</style>
